import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref } from "vue"

const _hoisted_1 = { class: "table-container" }
const _hoisted_2 = { class: "table" }
const _hoisted_3 = { class: "align-center" }
const _hoisted_4 = { class: "align-center" }
const _hoisted_5 = { class: "align-center" }
const _hoisted_6 = { class: "align-center" }
const _hoisted_7 = { class: "align-center" }
const _hoisted_8 = { class: "align-center" }
const _hoisted_9 = { class: "align-center" }
const _hoisted_10 = { class: "align-center" }
const _hoisted_11 = { class: "align-center" }
const _hoisted_12 = { class: "align-center" }
const _hoisted_13 = { class: "align-right fit-content" }
const _hoisted_14 = { class: "align-center" }
const _hoisted_15 = { class: "align-center" }
const _hoisted_16 = { class: "align-center" }
const _hoisted_17 = { class: "align-center" }
const _hoisted_18 = { class: "align-center" }
const _hoisted_19 = { class: "align-center" }
const _hoisted_20 = { class: "align-center" }
const _hoisted_21 = { class: "align-center" }
const _hoisted_22 = { class: "align-center" }
const _hoisted_23 = { class: "align-center" }

import { PropType } from 'vue'

import IfViewport from '@/components/common/IfViewport.vue'
import { StandingsTableRow } from '@/store/public/leagues.types'
import { formatFloat } from '@/utils/format'


export default /*@__PURE__*/_defineComponent({
  __name: 'LeagueStandingsTable',
  props: {
  rows: {
    type: Array as PropType<StandingsTableRow[]>,
    required: true,
  },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("table", _hoisted_2, [
      _createElementVNode("thead", null, [
        _createElementVNode("tr", null, [
          _cache[0] || (_cache[0] = _createElementVNode("th", { class: "fit-content" }, null, -1)),
          _createElementVNode("th", null, _toDisplayString(_ctx.$t('leagues.labels.team')), 1),
          _createElementVNode("th", null, _toDisplayString(_ctx.$t('leagues.labels.city')), 1),
          _createElementVNode("th", _hoisted_3, _toDisplayString(_ctx.$t('leagues.labels.total')), 1),
          _createVNode(IfViewport, { "min-width": "1024" }, {
            default: _withCtx(() => [
              _createElementVNode("th", _hoisted_4, _toDisplayString(_ctx.$t('leagues.labels.bonus')), 1),
              _createElementVNode("th", _hoisted_5, _toDisplayString(_ctx.$t('leagues.labels.raw')), 1),
              _createElementVNode("th", _hoisted_6, _toDisplayString(_ctx.$t('leagues.labels.games-played')), 1),
              _createElementVNode("th", _hoisted_7, _toDisplayString(_ctx.$t('leagues.labels.wins')), 1),
              _createElementVNode("th", _hoisted_8, _toDisplayString(_ctx.$t('leagues.labels.draws')), 1),
              _createElementVNode("th", _hoisted_9, _toDisplayString(_ctx.$t('leagues.labels.losses')), 1)
            ]),
            _: 1
          }),
          _createVNode(IfViewport, { "min-width": "512" }, {
            default: _withCtx(() => [
              _createElementVNode("th", _hoisted_10, _toDisplayString(_ctx.$t('leagues.labels.average')), 1),
              _createElementVNode("th", _hoisted_11, _toDisplayString(_ctx.$t('leagues.labels.best')), 1),
              _createElementVNode("th", _hoisted_12, _toDisplayString(_ctx.$t('leagues.labels.difference')), 1)
            ]),
            _: 1
          })
        ])
      ]),
      _createElementVNode("tbody", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.rows, (row, i) => {
          return (_openBlock(), _createElementBlock("tr", {
            key: `row-${i}`
          }, [
            _createElementVNode("td", _hoisted_13, _toDisplayString(i + 1) + ".", 1),
            _createElementVNode("td", null, _toDisplayString(row.name), 1),
            _createElementVNode("td", null, _toDisplayString(row.city), 1),
            _createElementVNode("td", _hoisted_14, _toDisplayString(_unref(formatFloat)(row.total_points, 0)), 1),
            _createVNode(IfViewport, { "min-width": "1024" }, {
              default: _withCtx(() => [
                _createElementVNode("td", _hoisted_15, _toDisplayString(_unref(formatFloat)(row.bonus, 0)), 1),
                _createElementVNode("td", _hoisted_16, _toDisplayString(_unref(formatFloat)(row.total_points_raw, 0)), 1),
                _createElementVNode("td", _hoisted_17, _toDisplayString(_unref(formatFloat)(row.match_count, 0)), 1),
                _createElementVNode("td", _hoisted_18, _toDisplayString(_unref(formatFloat)(row.win_count, 0)), 1),
                _createElementVNode("td", _hoisted_19, _toDisplayString(_unref(formatFloat)(row.draw_count, 0)), 1),
                _createElementVNode("td", _hoisted_20, _toDisplayString(_unref(formatFloat)(row.loss_count, 0)), 1)
              ]),
              _: 2
            }, 1024),
            _createVNode(IfViewport, { "min-width": "512" }, {
              default: _withCtx(() => [
                _createElementVNode("td", _hoisted_21, _toDisplayString(_unref(formatFloat)(row.average_points_raw, 2)), 1),
                _createElementVNode("td", _hoisted_22, _toDisplayString(_unref(formatFloat)(row.best_score, 0)), 1),
                _createElementVNode("td", _hoisted_23, _toDisplayString(_unref(formatFloat)(row.point_difference, 0)), 1)
              ]),
              _: 2
            }, 1024)
          ]))
        }), 128))
      ])
    ])
  ]))
}
}

})